/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1PersonSharedAcademicInstitutionDropdown200,
  GetApiV1PersonSharedAcademicInstitutionDropdown401,
  GetApiV1PersonSharedAcademicInstitutionDropdown500,
  GetApiV1PersonSharedAcademicInstitutionDropdownQueryResponse,
} from "../../types/personSharedController/GetApiV1PersonSharedAcademicInstitutionDropdown.ts";
import { dropDownRepositoryResponseSchema } from "../dropDownRepositoryResponseSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1PersonSharedAcademicInstitutionDropdown200Schema = z.array(
  z.lazy(() => dropDownRepositoryResponseSchema),
) as unknown as ToZod<GetApiV1PersonSharedAcademicInstitutionDropdown200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1PersonSharedAcademicInstitutionDropdown401Schema =
  z.any() as unknown as ToZod<GetApiV1PersonSharedAcademicInstitutionDropdown401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1PersonSharedAcademicInstitutionDropdown500Schema =
  z.any() as unknown as ToZod<GetApiV1PersonSharedAcademicInstitutionDropdown500>;

export const getApiV1PersonSharedAcademicInstitutionDropdownQueryResponseSchema =
  z.lazy(
    () => getApiV1PersonSharedAcademicInstitutionDropdown200Schema,
  ) as unknown as ToZod<GetApiV1PersonSharedAcademicInstitutionDropdownQueryResponse>;
